
class Footer
{
    constructor()
    {
        //this.init();
    }

    init()
    {
        //let feedback = new FeedBackForm(false ,'no', new Array<string>(), new Array<string>(), false, null, false);
        //feedback.init();
    }
}

export default Footer;